module.exports = __webpack_public_path__ + "img/佳裕达LOGO@2x.6cfb73b2.png";